import React, { useEffect } from "react";
import { BrandButton as Button } from "@/components";
import { Card, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import colors from "@/styles/Gradients.module.css";
import { FaLock, FaLockOpen } from "react-icons/fa";
import { IoLockClosedOutline, IoLockOpenOutline } from "react-icons/io5";
export default function TrackUserDashboard({
  selectedUser,
  auditLogs,
  onCancel,
  onLoaded,
}) {
  console.log("Rendering TrackUserDashboard", "auditLogs:", auditLogs);

  useEffect(() => {
    onLoaded();
  }, [onLoaded]);

  return (
    <>
      <Card.Header
        style={{
          backgroundColor: "#F16D09",
          borderBottom: "none",
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          flexDirection: "row",
          
        }}
      >
        <div className="col-3">
          <h1 className="mb-3" style={{ color: "#fff" }}>
            {selectedUser?.firstName} {selectedUser?.lastName}
          </h1>
        </div>
        <div className="col-6 d-flex align-items-center gap-3" style={{flexWrap: "wrap",}}>
          <span className={`ms-2 badge ${colors.sunshine} text-dark`}>
            {auditLogs?.accountConfirmed
              ? "Account Confirmed"
              : "Account Not Confirmed"}
          </span>
          <span className={`ms-4 badge text-light ${colors.hull}`}>
            {auditLogs?.emailConfirmed
              ? "Email Confirmed"
              : "Email Not Confirmed"}
          </span>
          <span
            className="ms-4 badge text-dark"
            style={{ backgroundColor: "#ffac0b" }}
          >
            {auditLogs?.termsAcceptedDate
              ? `Terms accepted: ${new Date(
                  auditLogs.termsAcceptedDate,
                ).toLocaleString("en-GB")}`
              : "Terms Not Accepted"}
          </span>
        </div>

        <div
          className="col-1 d-flex align-items-center justify-content-end"
          style={{ paddingRight: "3rem" }}
        >
          {auditLogs?.isLockedOut ? (
            <IoLockClosedOutline
              size={"50"}
              color="#fff"
              aria-label="Locked out"
            />
          ) : (
            <IoLockOpenOutline size={50} color="#fff" aria-label="Has access" />
          )}
        </div>

        <div className="col-2" style={{ fontSize: "var(--font-lg)", color: "#fff" }}>
          {auditLogs?.isLockedOut
            ? `Locked out until: ${new Date(auditLogs.lockoutEnd).toLocaleString("en-GB")}` : ""}
        </div>
      </Card.Header>
   
      <div className="row">
        <div className="col-12 p-3">
          {auditLogs ? (
            <Table striped bordered hover responsive className="w-100">
              <thead>
                <tr>
                  <th
                    colSpan={3}
                    style={{
                      textAlign: "left",
                      backgroundColor: "#ffc60b",
                      padding: "0.5rem",
                      fontSize: "var(--font-heading-sm)",
                    }}
                  >
                    RECENT ACTIVITY
                  </th>
                </tr>

                <tr style={{ fontSize: "var(--font-base)" }}>
                  <th>REPORT VIEWS</th>
                  <th>UNSUCCESSFUL REPORT VIEW ATTEMPTS</th>
                  <th>CONSECUTIVE FAILED LOGIN ATTEMPTS</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{auditLogs.recentReportViewSuccess ?? "-"}</td>
                  <td>{auditLogs.recentReportViewsFailed ?? "-"}</td>
                  <td>{auditLogs.consecutiveFailedAccessAttempts ?? "-"}</td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <p>No recent activity</p>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12 p-3">
          {auditLogs?.recentLogins?.length > 0 ? (
            <Table striped bordered hover responsive className="w-100">
              <thead>
                <tr>
                  <th
                    colSpan={4}
                    style={{
                      fontSize: "var(--font-heading-sm)",
                      textAlign: "left",
                      backgroundColor: "#ffc60b",
                      padding: "0.5rem",
                    }}
                  >
                    RECENT LOGIN HISTORY
                  </th>
                </tr>

                <tr style={{ fontSize: "var(--font-base)" }}>
                  <th>DATE AND TIME</th>
                  <th>STATUS</th>
                  <th>IP ADDRESS</th>
                  <th>MESSAGE</th>
                </tr>
              </thead>

              <tbody>
                {auditLogs.recentLogins.map((login, index) => (
                  <tr key={login.id ?? index}>
                    <td>{new Date(login.timeStamp).toLocaleString("en-GB")}</td>
                    <td>{login.success ? "Successful" : "Failed"}</td>
                    <td>{login.ipAddress}</td>
                    <td>{login.message}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No recent logins</p>
          )}
        </div>
      </div>
      <div>
        <Button style={{ marginTop: "1rem" }} onClick={onCancel}>
          Back to User List
        </Button>
      </div>
    </>
  );
}
